import { useEffect, useState, useMemo } from 'react';

const useJiraContext = () => {
    const [jiraContext, setJiraContext] = useState();

    useEffect(() => {
        (async () => {
            const isGlobalContext = await window.PlatformAdapter.isGlobalContext();
            if (!isGlobalContext) {
                window.PlatformAdapter.getJiraContext().then(setJiraContext);
            }
        })();
    }, []);
    return useMemo(
        () => ({
            projectKey: jiraContext?.jira?.project?.key,
            projectId: jiraContext?.jira?.project?.id,
            issueKey: jiraContext?.jira?.issue?.key,
            issueId: jiraContext?.jira?.issue?.id,
        }),
        [jiraContext],
    );
};

export default useJiraContext;
